<template>
  <div class="page page-with-bg login-page">
    <div class="page-form-wrap">
      <div class="page-form-header">
        <h1>Welcome!</h1>
        <div class="description">
          Set a password you can easily <br /> 
          remember to log in next time
        </div>
      </div>
      <div class="page-form-content">
        <b-form @submit.prevent="submit">

          <form-input-password v-model="password"
                               :validator="$v.password"
                               label="New Password">
          </form-input-password>

          <form-input-password v-model="confirmPassword"
                               :validator="$v.confirmPassword"
                               label="Confirm New Password">
          </form-input-password>
          <b-form-group class="form-buttons">
            <b-button size="lg"
                      variant="success"
                      type="submit">
              Save &amp; Continue
            </b-button>
          </b-form-group>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
  import { required, sameAs } from "vuelidate/lib/validators";
  import { password } from "utils/custom-validators";
  import formMixin from "mixins/form-mixin";

  export default {
    mixins: [formMixin],

    props: {
      userId: {
        type: String,
        required: true
      },
      token: {
        type: String,
        required: true
      }
    },

    data() {
      return {
        password: "",
        confirmPassword: "",
      };
    },

    validations: {
      password: {
        required,
        password
      },
      confirmPassword: {
        required,
        confirmPassword: sameAs("password")
      }
    },

    methods: {
      async onSubmit() {
        this.$router.push({ path: `../admin/create-profile-step-2`, query: { userId: this.userId, token: this.token, password: this.password } });
      },
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/styles/_mixins';

  .page {
    @include retina('/png/heart.png');
  }
</style>